var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavouriteFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.99 21a1.96 1.96 0 01-.68-.125 1.595 1.595 0 01-.6-.393l-1.512-1.42A70.534 70.534 0 014.2 13.883C2.733 12.188 2 10.372 2 8.435c0-1.543.504-2.834 1.511-3.875C4.52 3.52 5.77 3 7.263 3c.849 0 1.687.202 2.515.606.828.404 1.569 1.06 2.222 1.97.653-.91 1.394-1.566 2.222-1.97C15.05 3.202 15.888 3 16.737 3c1.494 0 2.744.52 3.752 1.56C21.496 5.6 22 6.892 22 8.435c0 1.958-.746 3.794-2.237 5.51a68.296 68.296 0 01-4.988 5.134l-1.496 1.403c-.172.178-.374.309-.605.393-.23.083-.459.125-.684.125z",
    fill: "currentColor"
  })));
}
SvgFavouriteFilled.displayName = 'FavouriteFilled';
export default SvgFavouriteFilled;